export default "__VITE_ASSET__B04$ujq9__"